import View from 'girder/views/View';

export default View;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/View.js